import React from "react";

const PageHeader = ({ titulo }) => {
  return (
    <>
      <div className="col-sm-4">
        <h2>{titulo}</h2>
        {/* <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="index.html">This is</a>
          </li>
          <li className="breadcrumb-item active">
            <strong>Breadcrumb</strong>
          </li>
        </ol> */}
      </div>
    </>
  );
};

export default PageHeader;
